import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '@application/store/useStore';
import { findCompanyDropdownFieldId, isExternalCompanyDropdownValue, resolveDefaultRegistrationHeaderLogo, resolveRegistrationHeaderLogo, resolveSelectedCompanyFromDropdownValue, resolveVdkGroepHeaderLogo, shouldApplyCompanyDropdownLogo } from '@application/utilities/registration-company';
const VDK_GROEP_LOGO_SRC = '/assets/images/vdk.png';
export const useEventRegistrationHeaderLogo = (embeddedPreview = false) => {
    const location = useLocation();
    const { control } = useFormContext();
    const { VDKEventForRegistration } = useAppSelector((state) => state.VDKEvent);
    const eventCompanies = VDKEventForRegistration?.eventCompanies ?? [];
    const companyFieldId = useMemo(() => findCompanyDropdownFieldId(VDKEventForRegistration?.formSteps), [VDKEventForRegistration?.formSteps]);
    const shouldUseDropdownLogo = shouldApplyCompanyDropdownLogo(location.pathname, embeddedPreview);
    const hasCompanyDropdown = Boolean(companyFieldId);
    const companyDropdownValue = useWatch({
        control,
        name: companyFieldId ?? '',
        disabled: !companyFieldId || !shouldUseDropdownLogo
    });
    const selectedCompany = useMemo(() => resolveSelectedCompanyFromDropdownValue(companyDropdownValue, eventCompanies), [companyDropdownValue, eventCompanies]);
    return useMemo(() => {
        if (hasCompanyDropdown && shouldUseDropdownLogo) {
            if (companyDropdownValue &&
                isExternalCompanyDropdownValue(companyDropdownValue, eventCompanies)) {
                return resolveVdkGroepHeaderLogo(VDK_GROEP_LOGO_SRC);
            }
            if (selectedCompany) {
                return resolveRegistrationHeaderLogo(selectedCompany, VDK_GROEP_LOGO_SRC);
            }
            return resolveVdkGroepHeaderLogo(VDK_GROEP_LOGO_SRC);
        }
        return resolveDefaultRegistrationHeaderLogo(eventCompanies, VDK_GROEP_LOGO_SRC);
    }, [
        hasCompanyDropdown,
        shouldUseDropdownLogo,
        companyDropdownValue,
        eventCompanies,
        selectedCompany
    ]);
};
